var _path, _path2, _line, _path3, _path4, _rect, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHome = function SvgHome(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2824 51.3713V22.8502C50.2782 22.596 50.2226 22.3452 50.1189 22.1125C50.0152 21.8799 49.8655 21.6701 49.6785 21.4955L31.0995 8.48159C30.757 8.1718 30.3096 8 29.8454 8C29.3812 8 28.9338 8.1718 28.5913 8.48159L10.0123 21.4955C9.82093 21.6666 9.66825 21.8757 9.56421 22.1092C9.46016 22.3426 9.40708 22.5951 9.40844 22.8502V51.3713",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 52H54",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.9,
    y1: -0.9,
    x2: 1.61428,
    y2: -0.9,
    transform: "matrix(1.37802e-05 1 -1 7.98511e-06 36.0371 44.2571)",
    className: "highlight",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7078 51.6856V34.8286C44.7078 33.724 43.8124 32.8286 42.7078 32.8286H36.1797C35.0751 32.8286 34.1797 33.724 34.1797 34.8285V51.6856",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2564 19V9.94287C46.2564 9.39059 45.8087 8.94287 45.2564 8.94287H42.302C41.7497 8.94287 41.302 9.39059 41.302 9.94287V15.2286",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.0527,
    y: 27.7999,
    width: 13.0054,
    height: 13.2,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17.7398,
    y1: 32.6142,
    x2: 23.3715,
    y2: 32.6142,
    className: "highlight",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/svg-icons/home.svg";